import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { ReleaseTrackerAuthnService } from "./ReleaseTrackerAuthnService";
import { of } from "rxjs";
import icon from "./../assets/svg/saltoLogo.svg";
import "./AuthHandler.css";

const defaultState = {
  loggedIn: false, // boolean
  email: "", // string
  getToken: () => of(""), // func() Observable<string>
  logout: () => { }, // func() void
};
export const AuthContext = React.createContext(defaultState);

// AuthHandler shows its children if the user is logged in, otherwise it redirects the user to the login screen.
class AuthHandler extends Component {
  constructor(props) {
    super(props);

    this.isPrivate = this.props.isPrivate;

    this.authnService = new ReleaseTrackerAuthnService(this.props.history);

    this.state = defaultState;
  }

  componentDidMount() {
    if (this.isPrivate) {
      const url = window.location.href;
      if (
        !this.authnService.isAuthenticated() &&
        !this.authnService.isAuthenticating()
      ) {
        const token = new URLSearchParams(window.location.search).get("token");
        const redirectTo = url.split("#")[0];
        this.authnService.startAuthnFlow(redirectTo, token).subscribe();
        // this will redirect to the login page
      } else if (this.authnService.isAuthenticating()) {
        this.authnService.completeAuthnProcess().subscribe({
          next: (result) => {
            if (result) {
              this.setState({
                loggedIn: true,
                email: this.authnService.getCurrentUser(),
                getToken: () => {
                  return this.authnService.getAccessToken();
                },
                logout: () => {
                  return this.authnService.logout();
                },
              });
            } else {
              // Something went wrong
              this.setState(defaultState);
            }
          },
          error: (err) => {
            console.error(err);
          },
          complete: () => { },
        });
        // this ends the login process, its async so the loading page will
        // show until we retrieve a valid token.
      }
    }
  }

  render() {
    if (!this.isPrivate || this.state.loggedIn) {
      return (
        <AuthContext.Provider value={this.state}>
          {this.props.children}
        </AuthContext.Provider>
      );
    } else {
      return (
        <div className="splash-screen">
          <img src={icon} alt="SALTO inspired access icon" />
        </div>
      );
    }
  }
}

AuthHandler.propTypes = {
  isPrivate: PropTypes.bool,
};

AuthHandler.defaultProps = {
  isPrivate: true,
};

export default withRouter(AuthHandler);
